import { combineReducers } from 'redux'
import form from './form'

const emergencyContactsReducer = combineReducers({
  form
})

export default emergencyContactsReducer
